import { render, staticRenderFns } from "./InterpretationHistoryForm.vue?vue&type=template&id=f6f41732&"
import script from "./InterpretationHistoryForm.vue?vue&type=script&lang=js&"
export * from "./InterpretationHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports